import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as serviceWorker from "./serviceWorker";
import { initializeFirebaseApp } from "./common/utils/firebaseHandler";

initializeFirebaseApp();

const clientId = process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID;

ReactDOM.render(
  <GoogleOAuthProvider clientId={clientId}>
    <App />
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
